// eslint-disable-next-line no-undef
export default () => localStorage.getItem('token');
